var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "navbar navbar-expand-lg fixed-top navbar-dark bg-dark",
      staticStyle: { "margin-bottom": "0" },
    },
    [
      _c(
        "a",
        {
          directives: [
            {
              name: "sanitizedHref",
              rawName: "v-sanitizedHref",
              value: `/#/decision/kanban/${_vm.workspaceId}/${_vm.projectId}`,
              expression: "`/#/decision/kanban/${workspaceId}/${projectId}`",
            },
          ],
          staticClass: "navbar-brand",
        },
        [_vm._v("Kanban")]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "collapse navbar-collapse", attrs: { id: "navBar" } },
        [
          _c("ul", { staticClass: "navbar-nav mr-auto" }, [
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [_vm._v("\n                    Manage\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/decision/attributes/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/decision/attributes/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Attributes")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/decision/forms/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/decision/forms/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Forms")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/decision/lists-manager/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/decision/lists-manager/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Lists")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/decision/notifications/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/decision/notifications/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Notifications")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/decision/dependencies/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/decision/dependencies/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Dependencies")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/decision/pages/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/decision/pages/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Request pages")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/decision/people/${_vm.workspaceId}/${_vm.projectId}`,
                        expression:
                          "`/#/decision/people/${workspaceId}/${projectId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("People")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/decision/goals/${_vm.workspaceId}/${_vm.projectId}`,
                      expression:
                        "`/#/decision/goals/${workspaceId}/${projectId}`",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("Evaluation")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/decision/assessments/${_vm.workspaceId}/${_vm.projectId}`,
                      expression:
                        "`/#/decision/assessments/${workspaceId}/${projectId}`",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("Assessments")]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "sanitizedHref",
                      rawName: "v-sanitizedHref",
                      value: `/#/decision/reports/${_vm.workspaceId}/${_vm.projectId}`,
                      expression:
                        "`/#/decision/reports/${workspaceId}/${projectId}`",
                    },
                  ],
                  staticClass: "nav-link",
                },
                [_vm._v("Reports")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "navbar-nav" }, [
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: { "data-toggle": "dropdown" },
                },
                [_vm._v("\n                    Account\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "sanitizedHref",
                        rawName: "v-sanitizedHref",
                        value: `/#/projects/${_vm.workspaceId}`,
                        expression: "`/#/projects/${workspaceId}`",
                      },
                    ],
                    staticClass: "dropdown-item",
                  },
                  [_vm._v("Back to workspace")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/#/organizations/users/dashboard" },
                  },
                  [_vm._v("My dashboard")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/#/organizations/users/account" },
                  },
                  [_vm._v("Manage your account")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "/organizations/sessions/close" },
                  },
                  [_vm._v("Sign out")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navBar",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }